/**
 * `/titles/:contentItemId` — the gated title page.
 *
 * One `RouteObject`, so the file is `title.route.tsx` (singular). An aggregate
 * array would be `title.routes.tsx`, and the importer knows the shape from the
 * name.
 *
 * The route resolves nothing and fetches nothing: **no `loader` in this repo
 * performs a data read.** A fetching loader would create a cache TanStack Query
 * does not know about, and the two would drift on every mutation — a class of
 * bug that reproduces only on the second visit to a route. The page component
 * owns its reads.
 *
 * **The segment is named `contentItemId` rather than `slug`.** `backend-content`
 * keys both title routes on `{contentItemId}` and publishes no slug → id
 * resolver; the UI/UX pack writes `[slug]` for uniformity across its file set,
 * and `frontend-landing` recorded the same reading as its own decision. The URL
 * shape is unchanged either way — what changes is that the value handed to the
 * detail read is one the callee actually registers.
 *
 * The chunk is split through the router's OWN `lazy`, not through `React.lazy`:
 * the data router awaits it before it renders the match, so the feature needs
 * no `Suspense` boundary of its own.
 */
import type { RouteObject } from 'react-router-dom';

export const titleRoute: RouteObject = {
  path: 'titles/:contentItemId',
  lazy: async () => {
    const { TitlePage } = await import('./TitlePage');
    return { Component: TitlePage };
  },
};
